import { render } from "./Faqs.vue?vue&type=template&id=5e4c14cd&scoped=true"
import script from "./Faqs.vue?vue&type=script&lang=js"
export * from "./Faqs.vue?vue&type=script&lang=js"

import "./Faqs.vue?vue&type=style&index=0&id=5e4c14cd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e4c14cd"

export default script